// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__Ns+Kk","sidebarHeading":"Sidebar_sidebarHeading__IQmIO","link":"Sidebar_link__9u6Es"};